import { render, staticRenderFns } from "./assignment-breakdown-modal.vue?vue&type=template&id=ebcbebc6&scoped=true"
import script from "./assignment-breakdown-modal.vue?vue&type=script&lang=js"
export * from "./assignment-breakdown-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-breakdown-modal.vue?vue&type=style&index=0&id=ebcbebc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcbebc6",
  null
  
)

export default component.exports